// Loads YouTube's IFrame Player API once and resolves with the global YT object.
let loading = null;

export function loadYouTube() {
  if (window.YT && window.YT.Player) return Promise.resolve(window.YT);
  if (loading) return loading;
  loading = new Promise((resolve, reject) => {
    const previous = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = () => {
      if (previous) previous();
      resolve(window.YT);
    };
    const s = document.createElement('script');
    s.src = 'https://www.youtube.com/iframe_api';
    s.onerror = () => { loading = null; reject(new Error('Could not load the YouTube player')); };
    document.head.appendChild(s);
  });
  return loading;
}
